(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mika-event-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const popup = document.querySelector('[data-mika-event-popup]');
    if (!popup) return;

    const delay = parseFloat(popup.dataset.delay || '2') * 1000;
    const cookieKey = popup.dataset.cookieKey;
    const cookieDays = parseInt(popup.dataset.cookieDays || '7', 10);

    function getCookie(name) {
      const match = document.cookie.match(new RegExp('(^|;\\s*)' + name + '=([^;]+)'));
      return match ? match[2] : null;
    }
    function setCookie(name, value, days) {
      const d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
    }
    function hide() {
      popup.setAttribute('hidden', '');
      setCookie(cookieKey, '1', cookieDays);
      document.body.style.overflow = '';
    }
    function show() {
      popup.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    }

    if (getCookie(cookieKey) === '1') return;

    setTimeout(show, delay);

    popup.querySelectorAll('[data-mika-event-popup-close]').forEach((el) => {
      el.addEventListener('click', hide);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !popup.hidden) hide();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
